import { createApp } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import App from "./App.vue";
import router from "./router";
import store from "@/store/store";
import VueCookies from "vue3-cookies";
import th from "element-plus/es/locale/lang/th";
import locale from "element-plus/lib/locale";

// Libary
import i18n from "./plugins/vue-i18n";
import ElementPlus from "element-plus";

// style
import "element-plus/dist/index.css";
import "./assets/style/components.scss";
import "./assets/style/style.scss";
//Vue3Lottie
import Vue3Lottie from "vue3-lottie";
import VueGtag from "vue-gtag";
import dayjs from "dayjs";
const buddhistEra = require("dayjs/plugin/buddhistEra");
// import buddhistEra from "dayjs/plugin/buddhistEra";

const app = createApp(App).component("fa", FontAwesomeIcon);
app.use(VueGtag, {
  config: { id: "G-5CC1J4P3N2" },
});
app.use(Vue3Lottie);
app.use(ElementPlus);
dayjs.locale("th"); // Use the Thai locale
library.add(fas);
app.use(router);
app.use(store);
app.use(VueCookies, {
  expireTimes: "1d",
});
app.use(i18n);
app.mount("#app");
